var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.value || _vm.value === '0')?_c('p',[_vm._v("\n  "+_vm._s(_vm.t('generic.na'))+"\n")]):_c('PercentageBarComponent',{attrs:{"value":_vm.percentage,"show-percentage":true}})}
var staticRenderFns = []

export { render, staticRenderFns }